import { useCreateCustomerMutation } from '@graphql/mutations/__generated__/customer.generated'
import { useSiteQuery } from '@graphql/queries/__generated__/site.generated'
import { Dialog } from '@mui/material'
import DialogContent from '@mui/material/DialogContent'
import { Form, Formik } from 'formik'
import { useSnackbar } from 'notistack'
import React, { useEffect, useState } from 'react'
import { useQueryParams } from 'use-query-params'
import { SHORT_SITE_NAME } from '../../../constants'
import FormikRecaptcha from '../Formik/FormikRecaptcha'
import { GlobalDialogFormsParams } from '../GlobalDialogForms'
import Footer from './Footer'
import { useTranslation } from 'react-i18next'
import { useMeQuery } from '@graphql/queries/__generated__/me.generated'

const FooterView: React.FC = () => {
  const { t } = useTranslation()
  const { enqueueSnackbar } = useSnackbar()
  const [, setParams] = useQueryParams(GlobalDialogFormsParams)
  const [subscribeEmail, setSubscribeEmail] = useState(null)
  const siteData = useSiteQuery({
    context: { notBatching: true },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  })
  const meQuery = useMeQuery({
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-first',
  })
  const [createCustomer] = useCreateCustomerMutation()

  if (!siteData.data) {
    return <footer />
  }

  const onSubmitSubscribe = async values => {
    try {
      await createCustomer({
        variables: {
          input: values,
        },
      })
      enqueueSnackbar(
        t('snackbarMessages.subscriberAdded', {
          defaultValue: `Check your inbox to confirm your {{siteName}} email subscription.`,
          siteName: SHORT_SITE_NAME,
        }),
        {
          variant: 'success',
        }
      )
    } catch (e) {
      enqueueSnackbar(e.message, { variant: 'error' })
    }
    setSubscribeEmail(null)
  }
  return (
    <>
      <Footer
        site={siteData.data.siteSettings}
        handleContactUs={() => setParams({ global_dialog_form: 'contactUs' }, 'replaceIn')}
        handleSignUp={() => setParams({ global_dialog_form: 'signUp' }, 'replaceIn')}
        onSubmitSubscribe={({ email }) => setSubscribeEmail(email)}
        isStaff={meQuery.data?.me?.isStaff || !!meQuery.data?.me?.permissions.length}
      />
      <Dialog
        open={!!subscribeEmail}
        onClose={() => setSubscribeEmail(null)}
        maxWidth='xs'
        PaperProps={{
          style: {
            minHeight: 'auto',
          },
        }}
      >
        <DialogContent>
          <Formik
            initialValues={{ email: subscribeEmail, captcha: '' }}
            enableReinitialize
            onSubmit={onSubmitSubscribe}
          >
            {form => {
              useEffect(() => {
                if (form.values.captcha) {
                  form.handleSubmit()
                }
              }, [form.values.captcha])
              return (
                <Form>
                  <FormikRecaptcha name='captcha' />
                </Form>
              )
            }}
          </Formik>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default React.memo(FooterView)
